module.exports = __webpack_public_path__ + "static/media/microstrip.dbd2a6e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/StackupDesign/Viewer/ResultViewer/SimulationModelImg/microstrip.svg
// module id = 1246
// module chunks = 0